module.exports = __webpack_public_path__ + "assets/img/sbx_avatar_active.893cf1a8.png";